// Путь: D:\QR\QR-WEB\dashboard\src\components\Admin\AdminGiftCards\AdminExchangeProducts.jsx
// Версия: 1.0.0
// Дата: 03.12.2025

import React, { useState, useEffect } from 'react';
import './AdminGiftCards.css';

const API_URL = process.env.REACT_APP_API_URL || 'https://qr-money.onrender.com';

const CATEGORIES = [
  { id: 'giftcard', label: '🎁 Gift Cards', color: '#667eea' },
  { id: 'mobile', label: '📱 Мобильный', color: '#10b981' },
  { id: 'gaming', label: '🎮 Игры', color: '#f59e0b' },
];

const ICONS = ['🛒', '🍎', '▶️', '🎵', '🎬', '👗', '📱', '🎮', '💰', '🎁', '⭐', '🔥'];

const AdminExchangeProducts = () => {
  const [products, setProducts] = useState([]);
  const [stats, setStats] = useState({});
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [filter, setFilter] = useState('all');
  const [formData, setFormData] = useState({
    category: 'giftcard',
    code: '',
    name: '',
    icon: '🎁',
    amounts: [10, 25, 50, 100],
    fee_percent: 3,
    is_active: true,
    sort_order: 0
  });

  const token = localStorage.getItem('authToken');

  useEffect(() => {
    fetchProducts();
    fetchStats();
  }, []);

  const fetchProducts = async () => {
    try {
      const res = await fetch(`${API_URL}/api/admin/exchange-products`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await res.json();
      if (data.success) {
        setProducts(data.data || []);
      }
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setLoading(false);
    }
  };

  const fetchStats = async () => {
    try {
      const res = await fetch(`${API_URL}/api/admin/exchange-products/stats`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await res.json();
      if (data.success) {
        setStats(data.data || {});
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const url = editingId 
        ? `${API_URL}/api/admin/exchange-products/${editingId}`
        : `${API_URL}/api/admin/exchange-products`;
      
      const res = await fetch(url, {
        method: editingId ? 'PUT' : 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });
      
      const data = await res.json();
      if (data.success) {
        setShowForm(false);
        setEditingId(null);
        resetForm();
        fetchProducts();
        fetchStats();
      } else {
        alert(data.error || 'Ошибка');
      }
    } catch (error) {
      alert('Ошибка: ' + error.message);
    }
  };

  const resetForm = () => {
    setFormData({
      category: 'giftcard',
      code: '',
      name: '',
      icon: '🎁',
      amounts: [10, 25, 50, 100],
      fee_percent: 3,
      is_active: true,
      sort_order: 0
    });
  };

  const handleEdit = (product) => {
    setFormData({
      category: product.category,
      code: product.code,
      name: product.name,
      icon: product.icon,
      amounts: product.amounts || [10, 25, 50, 100],
      fee_percent: parseFloat(product.fee_percent),
      is_active: product.is_active,
      sort_order: product.sort_order || 0
    });
    setEditingId(product.id);
    setShowForm(true);
  };

  const handleToggle = async (id) => {
    try {
      const res = await fetch(`${API_URL}/api/admin/exchange-products/${id}/toggle`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (res.ok) {
        fetchProducts();
        fetchStats();
      }
    } catch (error) {
      alert('Ошибка: ' + error.message);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Удалить продукт?')) return;
    try {
      const res = await fetch(`${API_URL}/api/admin/exchange-products/${id}`, {
        method: 'DELETE',
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (res.ok) {
        fetchProducts();
        fetchStats();
      }
    } catch (error) {
      alert('Ошибка: ' + error.message);
    }
  };

  const handleAmountsChange = (e) => {
    const values = e.target.value.split(',').map(v => parseInt(v.trim())).filter(v => !isNaN(v));
    setFormData({ ...formData, amounts: values });
  };

  const filteredProducts = filter === 'all' 
    ? products 
    : products.filter(p => p.category === filter);

  const getCategoryInfo = (cat) => CATEGORIES.find(c => c.id === cat) || { label: cat, color: '#666' };

  if (loading) {
    return <div className="admin-loading">Загрузка...</div>;
  }

  return (
    <div className="admin-giftcards">
      <div className="admin-page-header">
        <h1 className="admin-page-title">🎁 Gift Cards & Продукты</h1>
        <button 
          className="admin-btn admin-btn-primary"
          onClick={() => { setShowForm(!showForm); setEditingId(null); resetForm(); }}
        >
          {showForm ? '✕ Закрыть' : '+ Добавить продукт'}
        </button>
      </div>

      {/* Stats */}
      <div className="gc-stats">
        <div className="gc-stat">
          <span className="gc-stat-value">{stats.total || 0}</span>
          <span className="gc-stat-label">Всего</span>
        </div>
        <div className="gc-stat green">
          <span className="gc-stat-value">{stats.active || 0}</span>
          <span className="gc-stat-label">Активных</span>
        </div>
        <div className="gc-stat">
          <span className="gc-stat-value">{stats.categories || 0}</span>
          <span className="gc-stat-label">Категорий</span>
        </div>
      </div>

      {/* Form */}
      {showForm && (
        <div className="admin-card gc-form-card">
          <h3>{editingId ? '✏️ Редактирование' : '➕ Новый продукт'}</h3>
          <form onSubmit={handleSubmit} className="gc-form">
            <div className="gc-form-row">
              <div className="gc-form-group">
                <label>Категория</label>
                <select
                  value={formData.category}
                  onChange={(e) => setFormData({ ...formData, category: e.target.value })}
                >
                  {CATEGORIES.map(c => (
                    <option key={c.id} value={c.id}>{c.label}</option>
                  ))}
                </select>
              </div>
              <div className="gc-form-group">
                <label>Код (уникальный)</label>
                <input
                  type="text"
                  value={formData.code}
                  onChange={(e) => setFormData({ ...formData, code: e.target.value.toLowerCase() })}
                  placeholder="amazon, steam..."
                  required
                />
              </div>
            </div>

            <div className="gc-form-row">
              <div className="gc-form-group">
                <label>Название</label>
                <input
                  type="text"
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  placeholder="Amazon Gift Card"
                  required
                />
              </div>
              <div className="gc-form-group">
                <label>Иконка</label>
                <div className="gc-icon-picker">
                  {ICONS.map(icon => (
                    <button
                      key={icon}
                      type="button"
                      className={`gc-icon-btn ${formData.icon === icon ? 'active' : ''}`}
                      onClick={() => setFormData({ ...formData, icon })}
                    >
                      {icon}
                    </button>
                  ))}
                </div>
              </div>
            </div>

            <div className="gc-form-row">
              <div className="gc-form-group">
                <label>Суммы (через запятую)</label>
                <input
                  type="text"
                  value={formData.amounts.join(', ')}
                  onChange={handleAmountsChange}
                  placeholder="10, 25, 50, 100"
                />
              </div>
              <div className="gc-form-group">
                <label>Комиссия %</label>
                <input
                  type="number"
                  step="0.1"
                  min="0"
                  max="20"
                  value={formData.fee_percent}
                  onChange={(e) => setFormData({ ...formData, fee_percent: parseFloat(e.target.value) })}
                />
              </div>
              <div className="gc-form-group">
                <label>Сортировка</label>
                <input
                  type="number"
                  value={formData.sort_order}
                  onChange={(e) => setFormData({ ...formData, sort_order: parseInt(e.target.value) || 0 })}
                />
              </div>
            </div>

            <div className="gc-form-group">
              <label className="gc-checkbox">
                <input
                  type="checkbox"
                  checked={formData.is_active}
                  onChange={(e) => setFormData({ ...formData, is_active: e.target.checked })}
                />
                <span>Активен</span>
              </label>
            </div>

            <div className="gc-form-actions">
              <button type="submit" className="admin-btn admin-btn-primary">
                {editingId ? '💾 Сохранить' : '➕ Создать'}
              </button>
              <button type="button" className="admin-btn" onClick={() => setShowForm(false)}>
                Отмена
              </button>
            </div>
          </form>
        </div>
      )}

      {/* Filter */}
      <div className="gc-filter">
        <button 
          className={`gc-filter-btn ${filter === 'all' ? 'active' : ''}`}
          onClick={() => setFilter('all')}
        >
          📋 Все ({products.length})
        </button>
        {CATEGORIES.map(c => {
          const count = products.filter(p => p.category === c.id).length;
          return (
            <button 
              key={c.id}
              className={`gc-filter-btn ${filter === c.id ? 'active' : ''}`}
              onClick={() => setFilter(c.id)}
            >
              {c.label} ({count})
            </button>
          );
        })}
      </div>

      {/* Products Grid */}
      <div className="gc-grid">
        {filteredProducts.map(product => (
          <div key={product.id} className={`gc-card ${!product.is_active ? 'inactive' : ''}`}>
            <div className="gc-card-header" style={{ borderColor: getCategoryInfo(product.category).color }}>
              <span className="gc-card-icon">{product.icon}</span>
              <span className="gc-card-category">{getCategoryInfo(product.category).label}</span>
            </div>
            <div className="gc-card-body">
              <h4 className="gc-card-name">{product.name}</h4>
              <code className="gc-card-code">{product.code}</code>
              <div className="gc-card-amounts">
                {(product.amounts || []).map((a, i) => (
                  <span key={i} className="gc-amount-tag">${a}</span>
                ))}
              </div>
              <div className="gc-card-fee">
                Комиссия: <strong>{parseFloat(product.fee_percent).toFixed(1)}%</strong>
              </div>
              <span className={`gc-status ${product.is_active ? 'active' : 'inactive'}`}>
                {product.is_active ? '✅ Активен' : '⏸️ Выключен'}
              </span>
            </div>
            <div className="gc-card-actions">
              <button className="admin-btn admin-btn-sm" onClick={() => handleEdit(product)}>✏️</button>
              <button 
                className={`admin-btn admin-btn-sm ${product.is_active ? 'admin-btn-warning' : 'admin-btn-success'}`}
                onClick={() => handleToggle(product.id)}
              >
                {product.is_active ? '⏸️' : '▶️'}
              </button>
              <button className="admin-btn admin-btn-sm admin-btn-danger" onClick={() => handleDelete(product.id)}>🗑️</button>
            </div>
          </div>
        ))}
      </div>

      {filteredProducts.length === 0 && (
        <div className="admin-card">
          <div className="admin-empty">Продукты не найдены. Добавьте первый!</div>
        </div>
      )}
    </div>
  );
};

export default AdminExchangeProducts;